module.exports = __webpack_public_path__ + "img/close_c.6cb7e9ff.svg";